module.exports = __webpack_public_path__ + "img/cart.f2859f66.png";